<template>
  <AppGenericInput
    v-model="inputValue"
    v-bind="[inputProps, { items: years }]"
    component-name="v-autocomplete"
  />
</template>
<script>
import AppGenericInput from "@AppSelects/AppGenericInput.vue";
export default {
  name: "AppSelectYear",
  components: { AppGenericInput },
  props: {
    value: {
      type: [Number, Array],
      default: null
    },
    startYear: {
      type: Number,
      default: 2019
    },
    endYear: {
      type: Number,
      default: null
    },
    inputProps: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    years() {
      const range =
        (this.endYear || this.$dayjs().format("YYYY")) - this.startYear;
      const years = [];
      for (let i = 0; range >= i; i++) {
        years.unshift(this.startYear + i);
      }
      return years;
    }
  }
};
</script>
